<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'order-lists'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header order-align-center" style="margin: 15px 0 0;">
							<h1 class="fs-20 pc-hidde">{{$t('order.ordersummary')}}</h1>
							<div class="header-actions">
								<el-button type="primary" size="small" @click="handleWarehousePayment">{{$t('order.warehousepayment')}}
								</el-button>
							</div>
							<!-- <img src="../../assets/images/return.png" class="return-icon mobile-hidde" @click="iframeBack" /> -->
						</div>


						<div class="card-body">
							<div class="fs-17 padd-10 mobile-hidde">{{$t('order.ordersummary')}}</div>
							<div class="contents-wrap">
								<div class="contents-block hull-contents-block"><span class="o-label">
										{{$t('order.ordercode')}}：</span>{{ orderInfo.orderNo }}</div>
								<div class="contents-block hull-contents-block"><span class="o-label">
										{{$t('order.orderstatus')}}：</span>
									<el-tag :type="getStatusType(orderInfo.status)" disable-transitions>
										{{ getStatusLabel(orderInfo.status) }}
									</el-tag>
								</div>
								<div class="contents-block hull-contents-block"><span
										class="o-label">{{$t('order.customer')}}：</span>{{ orderInfo.customerName }}</div>
								<div class="contents-block hull-contents-block"><span class="o-label">{{$t('order.orderdate')}}：</span>{{ formatTo12Hour(orderInfo.createTimestr) }}</div>
								<div class="contents-block hull-contents-block"><span
										class="o-label">{{$t('form.email')}}：</span>{{ orderInfo.email }}</div>
								<div class="contents-block hull-contents-block"><span class="o-label">{{$t('common.totalamount')}}：</span>${{ orderInfo.totalPrice }} </div>
								<div class="contents-block hull-contents-block"><span class="o-label">{{$t('order.shippingaddress')}}：</span>{{ orderInfo.memberStoreAddress }}</div>
								<div class="contents-block hull-contents-block"><span class="o-label">{{$t('table.paymentmethod')}}：</span>{{ orderInfo.paymentMethod }}</div>
								<div class="contents-block hull-contents-block"><span class="o-label">{{$t('order.storeHouseprice')}}：</span>${{ orderInfo.storeHousePrice }} </div>
								<div class="contents-block hull-contents-block"><span
										class="o-label">{{$t('order.profit')}}：</span>${{ orderInfo.totalProfit }} </div>


                <!--物流信息-->
                <div class="contents-block hull-contents-block"><span
                    class="o-label">{{$t('order.logisticscompany')}}：</span>{{ orderInfo.logisticsCompany }} </div>
                <div class="contents-block hull-contents-block"><span
                    class="o-label">{{$t('order.logisticsnumber')}}：</span>{{ orderInfo.logisticsNumber }} </div>
                <div class="contents-block hull-contents-block"><span
                    class="o-label">{{$t('order.shiptime')}}：</span>{{ formatTo12Hour(orderInfo.shipTime)}} </div>
                <div class="contents-block hull-contents-block"><span
                    class="o-label">{{$t('order.receivetime')}}：</span>{{ formatTo12Hour(orderInfo.receiveTime) }} </div>


                <div class="contents-block hull-contents-block"><span class="o-label">{{$t('order.pickupstatus')}}：</span>
									<el-tag size="small">{{ orderInfo.procurementStatusName }}</el-tag>
								</div>

							</div>

							<div class="card-table-wrap ">
								<div class="order-table-wrapper">
									<el-table :data="orderProductList" border
										:header-cell-style="{backgroundColor: '#F8F8F8'}">
										<el-table-column prop="index" label="#" width="50"></el-table-column>
										<el-table-column prop="size" :label="$t('form.photo')" width="350">
											<template slot-scope="scope">
												<div class="table-product-block">
													<el-image :src="scope.row.icon" style="width: 60px; height: 60px">
														<div slot="error" class="image-slot">
															<i class="el-icon-picture-outline"></i>
														</div>
													</el-image>
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="productName" :label="$t('table.description')" min-width="250">
										</el-table-column>
										<el-table-column prop="method" :label="$t('table.deliverytype')" width="120">home_delivery
										</el-table-column>
										<el-table-column prop="productNum" :label="$t('table.qty')" width="70"></el-table-column>
										<el-table-column prop="unitPrice" :label="$t('table.baseprice')" width="120">
										</el-table-column>
										<el-table-column prop="totalPrice" :label="$t('table.total')" width="120"></el-table-column>

									</el-table>

								</div>


								<div class="mobile-order-cart-wrapper">
									<div class="order-card-item" v-for="(item,index) in orderProductList">
										<div class="o-card-infos">
											<img :src="item.icon" class="o-thumb"></img>
											<div class="o-r-inner">
												<div class="o-r-txt"><span class="p-label">{{$t('table.deliverytype')}}：</span><span>{{$t('table.homedelivery')}}</span></div>
												<div class="o-r-txt"><span
														class="p-label">{{$t('table.qty')}}：</span><span>{{item.productNum}}</span>
												</div>
												<div class="o-r-txt"><span class="p-label">{{$t('table.baseprice')}}：</span><span>${{item.unitPrice}} </span></div>
												<div class="o-r-txt"><span
														class="p-label">{{$t('table.total')}}：</span><span>${{item.totalPrice}} </span>
												</div>

											</div>
										</div>
										<div class="o-i-txt">
											<div class="o-label">{{$t('table.description')}}：</div>
											<div class="o-txt">{{item.productName}}</div>
										</div>
										<div class="o-price">{{$t('common.totalamount')}}：<span
												class="price-txt">${{item.totalPrice}}</span></div>
									</div>
								</div>
								<div class="order-detail-container">
									<div class="d-block">
										<div class="d-lable">{{$t('order.storeHouseprice')}}：</div>
										<div class="d-txt">${{orderInfo.storeHousePrice}}</div>
									</div>
									<div class="d-block">
										<div class="d-lable">{{$t('order.profit')}}：</div>
										<div class="d-txt">${{orderInfo.totalProfit}}</div>
									</div>
									<div class="d-block">
										<div class="d-lable">{{$t('order.subtotal')}}：</div>
										<div class="d-txt">${{orderInfo.totalPrice}}</div>
									</div>
									<div class="d-block">
										<div class="d-lable">{{$t('order.tax')}}：</div>
										<div class="d-txt">$0.00</div>
									</div>
									<div class="d-block">
										<div class="d-lable">{{$t('order.shipping')}}：</div>
										<div class="d-txt">$0.00</div>
									</div>
									<div class="d-block">
										<div class="d-lable">{{$t('order.totalprice')}}：</div>
										<div class="d-txt">${{orderInfo.totalPrice}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef" current="2"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		orderDetail,
		orderProduct,
		updateStaPayment
	} from "@/api/order";
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				tableLoading: false,

				orderInfo: {},
				orderProductList: [],
				tableData: []
			}
		},
		created() {
			this.getOrderDetail();
			this.getOrderProductList();
		},
		methods: {
      formatTo12Hour(timeStr) {
        if (!timeStr) return '';

        // 假设 createTimestr 是 "YYYY-MM-DD HH:mm:ss" 格式
        const date = new Date(timeStr);

        if (isNaN(date.getTime())) {
          // 如果不是标准日期格式，直接返回原值
          return timeStr;
        }

        // 使用 toLocaleString 方法转换为12小时制
        return date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      },
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			handleWarehousePayment() {
				if (!this.orderInfo.orderNo) {
					this.$message.error('Order number does not exist');
					return;
				}

				// 获取仓库价格
				const storeHousePrice = this.orderInfo.storeHousePrice;

				// 弹出确认支付框
				this.$confirm(`Pay with wallet $${storeHousePrice}`, 'Warehouse hose payment', {
					confirmButtonText: 'payment',
					cancelButtonText: 'Cancel',
					type: 'warning',
					dangerouslyUseHTMLString: true,
					center: true
				}).then(() => {
					// 用户点击支付后调用接口
					const orderNo = String(this.orderInfo.orderNo);
					updateStaPayment(orderNo).then(res => {
						if (res.code == 200) {
							this.$message.success(res.msg);
							this.getOrderDetail();
						} else {
							this.$message.error(res.msg);
						}
					}).catch(err => {
						this.$message.error('Operation failed, please try again');
					});
				}).catch(() => {
					// 用户点击取消
					this.$message.info('Payment cancelled');
				});
			},
			getStatusType(status) {
				const statusMap = {
					'3': 'warning', // Unpaid
					'4': 'info', // shipping
					'5': 'danger', // Cancelled
					'6': 'success', // confirmed
					'7': 'success', // Paid
					'8': 'warning', // Refunding
					'9': 'info', // Refunded
					'1': 'success', // finished
					'2': 'warning' // Pending
				};
				return statusMap[status] || 'info';
			},
			getStatusLabel(status) {
				const labelMap = {
					'4': 'shipping',
					'3': 'Cancel',
					'5': 'In transit',
					'6': 'confirmed',
					'1': 'Arrived',
					'2': 'Pending'
				};
				return labelMap[status] || 'Unknown';
			},
			getOrderDetail() {
				orderDetail({
					orderNo: this.$route.query.orderNo
				}).then(res => {
					if (res.code == 200) {
						this.orderInfo = res.data;

					} else {
						return false;
					}
				})
			},
			getOrderProductList() {
				orderProduct({
					orderNo: this.$route.query.orderNo
				}).then(res => {
					if (res.code == 200) {
						this.orderProductList = res.data;
					} else {
						return false;
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/order.css");

	.contents-wrap .contents-block {
		height: 45px;
		line-height: 45px;
	}

	.header-actions {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;
	}

	@media (min-width: 1280px) {
		.card-body {
			padding: 10px 0 30px;
			border: 1px solid #DDDDDD;
		}

		.contents-wrap {
			margin: 10px 20px 20px;
			border: unset;
			padding: 0 0 20px;
			border-bottom: 1px solid #DDDDDD;
		}

		.card-table-wrap {
			width: 100%;
			padding: 0 20px;
		}
	}

	.padd-10 {
		padding: 5px 20px 15px;
		border-bottom: 1px solid #DDDDDD;
	}


	/* 移动端适配 */
	@media (max-width: 768px) {
		.header-actions {
			justify-content: center;
		}

		.el-button {
			width: 100%;
			margin-top: 10px;
		}
	}
</style>
